import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mainImage", "mainLink", "counter", "thumb"];
  static values = {
    images: Array,
    index: { type: Number, default: 0 },
  };

  connect() {
    this.render();
  }

  select(event) {
    this.indexValue = Number(event.currentTarget.dataset.index);
    this.render();
  }

  render() {
    const img = this.imagesValue[this.indexValue];
    if (!img) return;

    if (this.hasMainImageTarget) {
      this.mainImageTarget.src = img.url;
      this.mainImageTarget.alt = img.caption || "";
      this.mainImageTarget.classList.remove("animate-fade-in");
      void this.mainImageTarget.offsetWidth;
      this.mainImageTarget.classList.add("animate-fade-in");
    }

    if (this.hasMainLinkTarget) {
      this.mainLinkTarget.dataset.index = String(this.indexValue);
    }

    if (this.hasCounterTarget) {
      const cur = String(this.indexValue + 1).padStart(2, "0");
      const total = String(this.imagesValue.length).padStart(2, "0");
      this.counterTarget.textContent = `${cur} / ${total}`;
    }

    this.thumbTargets.forEach((thumb, i) => {
      const active = i === this.indexValue;
      thumb.classList.toggle("border-accent", active);
      thumb.classList.toggle("border-transparent", !active);
    });
  }
}
